import { replacePathParams } from '@/api/utils';

export const multiSuggestPaths = {
  suggestionsCandidates: '/multicasesuggestionservice/suggestions/candidates',
  suggestion: '/multicasesuggestionservice/suggestions',
  suggestionById: '/multicasesuggestionservice/suggestions/:id',
  suggestionReviews: '/multicasesuggestionservice/suggestions/:id/reviews',
  suggestionReviewById: '/multicasesuggestionservice/suggestions/:id/reviews/:reviewId',
} as const;

export const getMultiSuggestApiUrl = {
  suggestionsCandidates: () => multiSuggestPaths.suggestionsCandidates,
  suggestion: () => multiSuggestPaths.suggestion,
  suggestionById: (id: string) => replacePathParams(multiSuggestPaths.suggestionById, { id }),
  suggestionReviews: (id: string) => replacePathParams(multiSuggestPaths.suggestionReviews, { id }),
  suggestionReviewById: (id: string, reviewId: string) =>
    replacePathParams(multiSuggestPaths.suggestionReviewById, { id, reviewId }),
};
